import moment from "moment";

export const COLUMNS = [
  {
    Header: "Data Do Feriado",
    accessor: "data",
    Cell: ({ value }) => {
      return moment(value).format("DD/MM/YYYY");
    },
    sortType: "datetime",
  },
  {
    Header: "Nome Do Feriado",
    accessor: "descricao",
  },
  {
    Header: "Nacional",
    accessor: "nacional",
  },
];
